/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { auth } from '../fn/authentication-api/auth';
import { Auth$Params } from '../fn/authentication-api/auth';
import { authorize } from '../fn/authentication-api/authorize';
import { Authorize$Params } from '../fn/authentication-api/authorize';
import { AuthToken } from '../models/auth-token';
import { logout1 } from '../fn/authentication-api/logout-1';
import { Logout1$Params } from '../fn/authentication-api/logout-1';
import { noAuth } from '../fn/authentication-api/no-auth';
import { NoAuth$Params } from '../fn/authentication-api/no-auth';
import { refreshToken } from '../fn/authentication-api/refresh-token';
import { RefreshToken$Params } from '../fn/authentication-api/refresh-token';
import { register } from '../fn/authentication-api/register';
import { Register$Params } from '../fn/authentication-api/register';
import { resetPassword } from '../fn/authentication-api/reset-password';
import { ResetPassword$Params } from '../fn/authentication-api/reset-password';
import { resetPasswordUpdate } from '../fn/authentication-api/reset-password-update';
import { ResetPasswordUpdate$Params } from '../fn/authentication-api/reset-password-update';

@Injectable({ providedIn: 'root' })
export class AuthenticationApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `authorize()` */
  static readonly AuthorizePath = '/oauth2/apple/authorize';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authorize()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authorize$Response(params: Authorize$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthToken>> {
    return authorize(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authorize$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authorize(params: Authorize$Params, context?: HttpContext): Observable<AuthToken> {
    return this.authorize$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthToken>): AuthToken => r.body)
    );
  }

  /** Path part for operation `register()` */
  static readonly RegisterPath = '/api/register';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `register()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  register$Response(params: Register$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthToken>> {
    return register(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `register$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  register(params: Register$Params, context?: HttpContext): Observable<AuthToken> {
    return this.register$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthToken>): AuthToken => r.body)
    );
  }

  /** Path part for operation `resetPassword()` */
  static readonly ResetPasswordPath = '/api/register/reset/password';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resetPassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resetPassword$Response(params: ResetPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return resetPassword(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resetPassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resetPassword(params: ResetPassword$Params, context?: HttpContext): Observable<void> {
    return this.resetPassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `resetPasswordUpdate()` */
  static readonly ResetPasswordUpdatePath = '/api/register/reset/password/new';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resetPasswordUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resetPasswordUpdate$Response(params: ResetPasswordUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return resetPasswordUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resetPasswordUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resetPasswordUpdate(params: ResetPasswordUpdate$Params, context?: HttpContext): Observable<void> {
    return this.resetPasswordUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `auth()` */
  static readonly AuthPath = '/api/auth';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `auth()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  auth$Response(params: Auth$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthToken>> {
    return auth(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `auth$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  auth(params: Auth$Params, context?: HttpContext): Observable<AuthToken> {
    return this.auth$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthToken>): AuthToken => r.body)
    );
  }

  /** Path part for operation `noAuth()` */
  static readonly NoAuthPath = '/api/noauth';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `noAuth()` instead.
   *
   * This method doesn't expect any request body.
   */
  noAuth$Response(params?: NoAuth$Params, context?: HttpContext): Observable<StrictHttpResponse<{
}>> {
    return noAuth(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `noAuth$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  noAuth(params?: NoAuth$Params, context?: HttpContext): Observable<{
}> {
    return this.noAuth$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

  /** Path part for operation `logout1()` */
  static readonly Logout1Path = '/api/logout';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `logout1()` instead.
   *
   * This method doesn't expect any request body.
   */
  logout1$Response(params?: Logout1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return logout1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `logout1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  logout1(params?: Logout1$Params, context?: HttpContext): Observable<void> {
    return this.logout1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `refreshToken()` */
  static readonly RefreshTokenPath = '/api/auth/refresh';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `refreshToken()` instead.
   *
   * This method doesn't expect any request body.
   */
  refreshToken$Response(params?: RefreshToken$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthToken>> {
    return refreshToken(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `refreshToken$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  refreshToken(params?: RefreshToken$Params, context?: HttpContext): Observable<AuthToken> {
    return this.refreshToken$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthToken>): AuthToken => r.body)
    );
  }

}
